export default __webpack_public_path__ + "static/media/Distributed-Acousting-Sensing-System_Banner-Image-1536x418.03a7327a.jpg";